import officeDark from '@/assets/img/users-cases/office-dark.webp';
import officeDarkHow from '@/assets/img/users-cases/office-dark-how.webp';
import officeDarkResult from '@/assets/img/users-cases/office-dark-result.webp';

export default {
  slug: 'office-3d-dark',
  order: 3,
  title: 'Office 3D Dark',
  subtitle: 'Moody 3D interior visuals and cinematic walkthroughs',
  tags: ['OfficeDesign', 'DarkOffice'],

  images: {
    hero: officeDark,
    aboutTop: officeDarkHow,
    aboutBottom: officeDarkResult,
  },

  howText:
    'Developed 2D and 3D office plans for open-space zones, co-working areas, private offices, and executive suites. Interior features include dark color palettes, accent lighting, and materials that highlight functionality and style.',

  resultText:
    'Ready 2D and 3D plans allow developers to quickly showcase offices, produce professional marketing materials, and speed up sales processes, ensuring commercial properties are presented at their best.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: ['office-standard', 'office-elegance'],
};
